
export default class CommonFunctions {
    static setupAjaxCalls() {
        $.ajaxSetup({
            xhrFields: {
                withCredentials: true
            }
        });
    }

    static setKendoPreInitClass() {
       $(document.documentElement).addClass("invisible"); //anti flicker (fouc kendo)
    }

    static removeKendoPreInitClass() {
       $(document.documentElement).removeClass("invisible"); //anti flicker (fouc kendo)
    }

    // Formats a byte count into a human-readable size, e.g. 1048576 => "1 MB", 1572864 => "1.5 MB".
    static formatFileSize(bytes: number): string {
        if (!bytes || bytes <= 0) {
            return "0 B";
        }
        const units = ["B", "KB", "MB", "GB", "TB"];
        const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
        const value = bytes / 1024 ** exponent;
        const rounded = Number.isInteger(value) ? value.toString() : value.toFixed(1);
        return `${rounded} ${units[exponent]}`;
    }

    static formatDateToLocalIsoFormat(date: Date): string {
        if (!date) {
            return null;
        }
        return `${date.getFullYear()}-` +
            `${(date.getMonth() + 1).toString().padStart(2, '0')}-` +
            `${date.getDate().toString().padStart(2, '0')}`;
    }

    static compareArrays<T>(arr1: Array<T>, arr2: Array<T>) {
        return arr1.length === arr2.length && arr1.every((value, index) => value === arr2[index]);
    }

    static mapPopup(): any {
        const existingPopup = $(document).find("#mapPopup");
        if (existingPopup.length === 1) {
            return existingPopup.data("kendoPopup");
        }
        return $("<div id='mapPopup'>cxvgxcg</div>")
            .appendTo(document.body)
            .kendoPopup()
            .data("kendoPopup");
    }

    static mapOnShapeMouseEnter(e: any) {
        e.shape.options.set('fill.opacity', 1);
        const oe = e.originalEvent;
        const x = oe.pageX || oe.clientX;
        const y = oe.pageY || oe.clientY;

        const name = e.shape.dataItem.Title;
        const popup = CommonFunctions.mapPopup();
        popup.element.html(`<div class='mapPopupInner'>${name}</div>`);
        popup.open(x - 50, y - 70);
    }

    static mapOnShapeMouseLeave(e: any) {
        if (!$(e.originalEvent.relatedTarget).is(".k-popup, .k-animation-container")) {
            CommonFunctions.mapPopup().close();
        } else {
            CommonFunctions.mapPopup().close();
        }
        CommonFunctions.mapPopup().element.kendoStop(true, true);
    }

    static mapFitToBounds(map: kendo.dataviz.ui.Map, geoJsonLayerIndex: number = 0) {
        // Inline scripts in card partials sometimes run before Kendo's deferred
        // widget init completes, so the map widget may not be ready yet.
        if (!map || !map.layers || !map.layers[geoJsonLayerIndex]) return;
        const layer = map.layers[geoJsonLayerIndex];
        const dataSource = layer.dataSource;

        dataSource.fetch().then(() => {
            const shapes = dataSource.view();

            let minLat = 90, maxLat = -90, minLng = 180, maxLng = -180;

            shapes.forEach(shape => {
                const { type, coordinates } = shape.geometry;
                const points: [number, number][] = [];

                if (type === "Polygon") {
                    coordinates.forEach(ring => ring.forEach(p => points.push(p)));
                } else if (type === "MultiPolygon") {
                    coordinates.forEach(polygon =>
                        polygon.forEach(ring => ring.forEach(p => points.push(p)))
                    );
                }

                points.forEach(([lng, lat]) => {
                    minLat = Math.min(minLat, lat);
                    maxLat = Math.max(maxLat, lat);
                    minLng = Math.min(minLng, lng);
                    maxLng = Math.max(maxLng, lng);
                });
            });

            if (!isFinite(minLat) || !isFinite(minLng)) return;

            const nw = new kendo.dataviz.map.Location(maxLat, minLng);
            const se = new kendo.dataviz.map.Location(minLat, maxLng);
            const extent = new kendo.dataviz.map.Extent(nw, se);

            const container = map.element[0];
            const width = container.clientWidth;
            const height = container.clientHeight;

            const meanLat = (minLat + maxLat) / 2;
            const latDiff = Math.abs(maxLat - minLat);
            const lngDiff = Math.abs(maxLng - minLng);

            const scaleY = 1 / Math.cos(meanLat * Math.PI / 180);
            const scaledLatDiff = latDiff * scaleY;

            const minWidth = width / (lngDiff / 360);
            const minHeight = height / scaledLatDiff * 360;

            const minSize = Math.min(Math.ceil(minWidth), Math.ceil(minHeight));

            map.setOptions({
                zoom: 0,
                minZoom: 0,
                maxZoom: 0,
                minSize: minSize
            });

            map.center(extent.center());
        });
    }

    static htmlEncode(value: string) {
        return $('<div/>').text(value).html();
    }

    static htmlDecode(value: string) {
        return $('<div/>').html(value).text();
    }

    static isEven(n: number): boolean {
        return n % 2 === 0;
    }

    static isOdd(n: number): boolean {
        return Math.abs(n % 2) === 1;
    }

    static formatLongText(text: string) {
        return `<span title='${text}'>${text.substring(0, 50)}...</span>`;
    }

    static isNullOrWhitespace(input): boolean {
        if (typeof input === 'undefined' || input == null) return true;
        if (typeof (input) === 'string') {
            return input.replace(/\s/g, '').length < 1;
        }
        return false;
    }

    static showXhrError(xhr) {
        const msg = xhr.getResponseHeader("message");
        if (msg && !CommonFunctions.isNullOrWhitespace(msg)) {
            CommonFunctions.showError(TextResources.Views_Fehler, CommonFunctions.htmlDecode(msg));
        } else if (xhr.status !== 0 && xhr.readyState !== 0 && !CommonFunctions.isNullOrWhitespace(xhr.responseText)) {
            CommonFunctions.showError(TextResources.Views_Fehler, xhr.responseText);
        } else if (xhr.status !== 0 && xhr.readyState !== 0 && !CommonFunctions.isNullOrWhitespace(xhr.statusText)) {
            CommonFunctions.showError(TextResources.Views_Fehler, xhr.statusText);
        } else if (xhr.status !== 0 && xhr.readyState !== 0) {
            CommonFunctions.showError(TextResources.Views_Fehler, TextResources.Error_Generic);
        }
    }

    static get(url: string, doneFunction?: (result: any) => any, failFunction?: (result: any) => any) {
        $.ajax({
            type: 'GET',
            url
        }).done((item) => {
            if (doneFunction != null) {
                doneFunction(item);
            }
        }).fail((result) => {
            if (failFunction != null) {
                failFunction(result);
            }
        });
    }

    static getWithData(url: string, data?, doneFunction?: (result: any) => any, failFunction?: (result: any) => any) {
        return $.ajax({
            type: 'GET',
            url,
            data
        }).done((item) => {
            if (doneFunction != null) {
                doneFunction(item);
            }
        }).fail((result) => {
            if (failFunction != null) {
                failFunction(result);
            } else {
                CommonFunctions.showXhrError(result);
            }
        });
    }

    static post(url: string, value: any, doneFunction?: Function, failFunction?: Function) {
        $.ajax({
            url,
            type: 'POST',
            data: JSON.stringify(value),
            contentType: 'application/json;charset=utf-8'
        })
            .done((result) => {
                if (doneFunction != null) {
                    doneFunction(result);
                }
            }).fail((result) => {
                if (failFunction != null) {
                    failFunction(result);
                } else {
                    CommonFunctions.showXhrError(result);
                }
            });
    }

    static convertOdataValuesToObject(value) {
        return value.value;
    }

    static showInformation(title: string, message: string, autoHideAfter: number = 5000) {
        CommonFunctions.showNotification(title, message, autoHideAfter, "info");
    }

    static showSuccess(title: string, message: string, autoHideAfter: number = 5000) {
        CommonFunctions.showNotification(title, message, autoHideAfter, "ok");
    }

    static showError(title: string, message: string, autoHideAfter: number = 5000) {
        CommonFunctions.showNotification(title, message, autoHideAfter, "error");
    }

    static showNotification(title: string, message: string, autoHideAfter: number, notificationType: "info" | "ok" | "error") {
        const notification = $("#notification").data().kendoNotification;
        notification.setOptions({ autoHideAfter: autoHideAfter });
        try {
            notification.show({
                title,
                message,
            }, notificationType);
            const container = $(notification.options.appendTo);
            container.scrollTop(container[0].scrollHeight);
        } catch (e) {
            console.error(e);
        }
    }

    static showYesNo(title: string, message: string, yesAction: () => void, noAction?: () => void) {
        const $el = $("<div></div>").appendTo("body");
        $el.kendoDialog(<any>{
            title, content: message, actions: [
                { text: TextResources.Views_Ja, primary: true, action: yesAction },
                { text: TextResources.Views_Nein, action: noAction },
            ]
        }).data("kendoDialog").open();
    }

    static showConfirm(title: string, message: string, success: () => void, abort?: () => void) {
        const $el = $("<div></div>").appendTo("body");
        $el.kendoConfirm(<any>{ title, content: message, buttonLayout: "normal" })
            .data("kendoConfirm").result
            .done(success).fail(() => {
                if (abort) {
                    abort();
                }
            });
    }

    static async showConfirmAsync(title: string, message: string): Promise<boolean> {
        return new Promise(res => {
            this.showConfirm(title, message, () => res(true), () => res(false));
        });
    }

    static addValidation(element: JQuery) {
        if (!element.attr('data-val')) {
            element.attr('data-val', 'true');
        }
    }

    static addRequiredValidation(element: JQuery, error: string) {
        CommonFunctions.addValidation(element);
        element.attr("data-val-required", error);
    }

    static addPhoneNumberValidation(element: JQuery, error: string) {
        CommonFunctions.addValidation(element);
        element.attr("data-val-phonenumber", error);
    }

    static addRegexValidation(element: JQuery, pattern: string, error: string) {
        CommonFunctions.addValidation(element);
        element.attr("data-val-regex", error);
        element.attr("data-val-regex-pattern", pattern);
    }

    static addEmailValidation(element: JQuery, error: string) {
        CommonFunctions.addValidation(element);
        element.attr("data-val-regex", error);
        element.attr("data-val-regex-pattern", "^[^@]+@[^@]+$");
    }

    static addUrlValidation(element: JQuery, error: string) {
        CommonFunctions.addValidation(element);
        element.attr("data-val-regex", error);
        element.attr("data-val-regex-pattern", "^(www\\.[A-Za-z0-9\\-]+\\.|((https?|ftp|news|file)://))[A-Za-z0-9\\-]+[\\w/:@=\\.\\+\\?,#%&\\~]*$");
    }

    static isEmpty(str: string) {
        return (!str || str.length === 0);
    }

    static stringToBool(value: any) {
        if (typeof (value) === "boolean") {
            return value;
        }
        switch (value.toString().toLowerCase()) {
            case "false":
            case "no":
            case "0":
            case "":
                return false;
            default:
                return true;
        }
    }

    static isNumeric(value) {
        return (value == Number(value));
    }

    static isLoading(selector: JQuery, modal = true) {
        kendo.ui.progress(selector, true);
        if (!modal) {
            $(".k-loading-mask").css("pointer-events", "none");
        }
    }

    static isLoadeded(selector: JQuery) {
        kendo.ui.progress(selector, false);
    }

    static setTabStatus(status: string, actionUrl: string, tabId = "grid") {
        const tabstrip = $(".k-tabstrip").data("kendoTabStrip");
        const tab = $(`.k-tabstrip [data-id=${tabId}]`);
        tab.find(".k-link").text(status);
        tab.append(`<a data-type="showall" title="${TextResources.Views_RemoveFilterShowAll}" class="k-button k-button-sm k-rounded-full k-button-solid k-button-solid-primary"><span><i class="icon-cross icons"></i></span></a>`);
        tabstrip.tabGroup.on("click", "[data-type='showall']", (e) => {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = actionUrl;
        });
    }

    static saveInputElements(element: JQuery): { [key: string]: any; } {
        const inputData: { [key: string]: any; } = {};
        const inputElements = element.find('input, select');
        for (let i = 0; i < inputElements.length; i++) {
            if ($(inputElements[i]).data().kendoNumericTextBox) {
                inputData[inputElements[i].id] = $(inputElements[i]).data().kendoNumericTextBox.value();
            } else if ($(inputElements[i]).data().kendoDatePicker) {
                inputData[inputElements[i].id] = $(inputElements[i]).data().kendoDatePicker.value();
            } else if ($(inputElements[i]).data().kendoYearlessDatePicker) {
                inputData[inputElements[i].id] = $(inputElements[i]).data().kendoYearlessDatePicker.value();
            } else if ($(inputElements[i]).data().kendoDateTimePicker) {
                inputData[inputElements[i].id] = $(inputElements[i]).data().kendoDateTimePicker.value();
            } else if ($(inputElements[i]).data().kendoTimePicker) {
                inputData[inputElements[i].id] = $(inputElements[i]).data().kendoTimePicker.value();
            } else if ($(inputElements[i]).data().kendoDropDownList) {
                inputData[inputElements[i].id] = $(inputElements[i]).data().kendoDropDownList.value();
            } else if ($(inputElements[i]).data().kendoMultiSelect) {
                inputData[inputElements[i].id] = $(inputElements[i]).data().kendoMultiSelect.value();
            } else if ($(inputElements[i]).data().kendoMultiSelectWithInsert) {
                inputData[inputElements[i].id] = $(inputElements[i]).data().kendoMultiSelectWithInsert.value();
            } else {
                inputData[inputElements[i].id] = $(inputElements[i]).val();
            }
        }
        return inputData;
    }

    static restoreInputElements(element: JQuery, idValueMap: { [key: string]: any; }) {
        const inputElements = element.find('input, select');
        for (let i = 0; i < inputElements.length; i++) {
            if (idValueMap[inputElements[i].id] !== undefined) {
                if ($(inputElements[i]).data().kendoNumericTextBox) {
                    $(inputElements[i]).data().kendoNumericTextBox.value(idValueMap[inputElements[i].id]);
                } else if ($(inputElements[i]).data().kendoDatePicker) {
                    $(inputElements[i]).data().kendoDatePicker.value(idValueMap[inputElements[i].id]);
                } else if ($(inputElements[i]).data().kendoYearlessDatePicker) {
                    $(inputElements[i]).data().kendoYearlessDatePicker.value(idValueMap[inputElements[i].id]);
                } else if ($(inputElements[i]).data().kendoDateTimePicker) {
                    $(inputElements[i]).data().kendoDateTimePicker.value(idValueMap[inputElements[i].id]);
                } else if ($(inputElements[i]).data().kendoTimePicker) {
                    $(inputElements[i]).data().kendoTimePicker.value(idValueMap[inputElements[i].id]);
                } else if ($(inputElements[i]).data().kendoDropDownList) {
                    $(inputElements[i]).data().kendoDropDownList.value(idValueMap[inputElements[i].id]);
                } else if ($(inputElements[i]).data().kendoMultiSelect) {
                    $(inputElements[i]).data().kendoMultiSelect.value(idValueMap[inputElements[i].id]);
                } else if ($(inputElements[i]).data().kendoMultiSelectWithInsert) {
                    $(inputElements[i]).data().kendoMultiSelectWithInsert.value(idValueMap[inputElements[i].id]);
                } else {
                    $(inputElements[i]).val(idValueMap[inputElements[i].id]);
                }
            }
        }
    }

    static loadPartialView(element: JQuery, action: string, arg?: any, callback?: () => void) {
        let loading = $(document).data("partialLoading") || 0;
        $(document).data("partialLoading", ++loading);
        kendo.destroy(element);
        element.load(action, arg, () => {
            let loaded = $(document).data("partialLoading") || 1;
            $(document).data("partialLoading", --loaded);
            if (!loaded) {
                $(document).trigger("loadedPartially");
            }
            if (callback !== undefined) {
                callback();
            }
        });
    }

    static async loadPartialViewAsync(element: JQuery, action: string, arg?: any): Promise<void> {
        return new Promise(res => {
            let loading = $(document).data("partialLoading") || 0;
            $(document).data("partialLoading", ++loading);
            kendo.destroy(element);
            element.load(action, arg, () => {
                let loaded = $(document).data("partialLoading") || 1;
                $(document).data("partialLoading", --loaded);
                if (!loaded) {
                    $(document).trigger("loadedPartially");
                }
                res();
            });
        })
    }

    static moveReferenceTokensToPopupTitle(container: JQuery) {
        const windowContent = container.closest(".k-window-content");
        const tokens = (windowContent.length > 0 ? windowContent : container.parent()).find(".referenceTokens");
        if (tokens.length === 0) {
            return;
        }

        const title = container.closest(".k-window").find(".k-window-title");
        if (title.length > 0) {
            tokens.insertAfter(title);
        }
        tokens.show();
    }

    static loadPartialAndRestoreInputValues(element: JQuery, restoreInputs: boolean, action: string) {
        let inputData: { [key: string]: any; } = {};
        if (restoreInputs) {
            inputData = CommonFunctions.saveInputElements(element);
        }
        CommonFunctions.loadPartialView(element,
            action,
            undefined,
            () => {
                if (restoreInputs) {
                    CommonFunctions.restoreInputElements(element, inputData);
                    $(".navigationAndCommandBarBottom").show();
                }
            });
    }

    static onReady(handler: () => void) {
        if ($(document).data("partialLoading")) {
            $(document).one("loadedPartially", handler);
        } else {
            $(document).ready(handler);
        }
    }

    static openImageInPopup(sender) {
        let html;
        if (sender.sender) {
            html = $(sender.sender.element).find("img").clone();
        } else {
            html = $(sender).clone();
            html = $(html).removeClass("gridBase64Column");
        }
        const popup = $('#imageWindow').data("kendoWindow");
        if (popup) {
            popup.destroy();
        }
        $("<div id='imageWindow'></div>").appendTo(document.body).kendoWindow({
            visible: true,
            modal: true
        }).data().kendoWindow.content(html).center();
    }

    static openInModalWindow(windowId: string, action: string, title: string, modal: boolean, width?: number, maxWidth?: number, maxHeight?: number): kendo.ui.Window {
        let popupWindow = $(`#${windowId}`).data("kendoWindow");
        if (popupWindow) {
            popupWindow.destroy();
        }
        const popup = $(`<div id='${windowId}'></div>`).appendTo(document.body);

        let resizeObs: ResizeObserver;

        popupWindow = $(popup).kendoWindow({
            maxWidth: maxWidth ?? Infinity,
            maxHeight: maxHeight ?? Infinity,
            minWidth: 320,
            draggable: true,
            visible: false,
            iframe: false,
            resizable: false,
            refresh: () => {
                CommonFunctions.isLoadeded($("body"));
                popupWindow.center().open();
                const contentEl = popupWindow.element[0];
                if (contentEl) {
                    resizeObs?.disconnect();
                    resizeObs = new ResizeObserver(() => popupWindow.center());
                    resizeObs.observe(contentEl);
                }
            },
            deactivate: () => {
                resizeObs?.disconnect();
                popupWindow.destroy();
            }
        }).data().kendoWindow;

        popupWindow.setOptions({
            modal,
            width,
            title
        });

        CommonFunctions.isLoading($("body"), false);
        popupWindow.refresh({ url: action });

        return popupWindow;
    }

    static openInPopupWindowSilent(action: string, title: string, modal: boolean, width?: number, maxWidth?: number, maxHeight?: number) {
        CommonFunctions.openInPopupWindow(action, title, modal, width, maxWidth, maxHeight);
    }

    static openInPopupWindow(action: string, title: string, modal: boolean, width?: number, maxWidth?: number, maxHeight?: number): kendo.ui.Window {
        return CommonFunctions.openInModalWindow('popupWindow', action, title, modal, width, maxWidth, maxHeight);
    }

    static openInPopupWindowHandler(action, title, modal, width, maxWidth?: number, maxHeight?: number) {
        return () => CommonFunctions.openInPopupWindow(action, title, modal, width, maxWidth, maxHeight);
    }

    static isPopupWindowOpen() {
        const windows = $(".k-window").not(".hideToolbarWindow");
        return windows.length > 0;
    }

    static getPopupWindow() {
        return $("#popupWindow").data("kendoWindow");
    }

    static closePopupWindow() {
        CommonFunctions.getPopupWindow().close();
    }

    static closeContainingWindow(element: JQuery) {
        const popupWindow = element.closest(".k-window-content").data("kendoWindow");
        popupWindow.close();
    }

    static centerPopupWindow(e?) {
        if (e?.target) {
            const containingWindow = $(e.target).closest(".k-window-content").data("kendoWindow");
            containingWindow?.center();
        } else {
            CommonFunctions.getPopupWindow()?.center();
        }
    }

    static enableFormValidation(formSelector: JQuery): kendo.ui.Validator {
        const selector = formSelector.kendoValidator(<any>(({
            validateInput: (e) => {
                if (!e.valid) {
                    $(e.input).closest(".inputContainer").addClass("invalid");
                } else {
                    $(e.input).closest(".inputContainer").removeClass("invalid");
                }
            }
        })));
        if (selector && selector.data()) {
            return selector.data().kendoValidator;
        }
        return undefined;
    }

    static datasourceError(e: any) {
        if (e.errors) {
            const messages: string[] = [];
            // ModelState errors arrive as { "<field>": { errors: ["<message>"] } }.
            $.each(e.errors, (key, value) => {
                if (typeof (value) === "string") {
                    messages.push(CommonFunctions.htmlEncode(value));
                } else if (typeof (value) === "object" && value !== null && 'errors' in value) {
                    $.each(value.errors,
                        (index, error) => {
                            messages.push(CommonFunctions.htmlEncode(String(error)));
                        });
                }
            });
            CommonFunctions.showError(TextResources.Views_Fehler,
                messages.length > 0 ? messages.join("<br/>") : TextResources.Error_Generic);
        } else {
            CommonFunctions.showXhrError(e.xhr);
        }
    }

    static formatDateTime(dateTime: Date, includeDays = false, includeSeconds = false): string {
        let result = "";
        if (includeDays) {
            const days = dateTime.getDay();
            if (days > 0) {
                result += `${days}d `;
            }
        }
        const hours = dateTime.getHours();
        if (hours > 0) {
            result += `${hours}h `;
        }
        const minutes = dateTime.getMinutes();
        const seconds = dateTime.getSeconds();
        result += `${minutes}m `;
        if (includeSeconds) {
            result += `${seconds}s`;
        }
        return result.trim();
    }

    static formatTimeSpan(durationTicks: number, includeDays = false, includeSeconds = false): string {
        let result = "";
        let totalSeconds = durationTicks / 10000000;
        if (includeDays) {
            const days = Math.floor(totalSeconds / 86400);
            totalSeconds -= days * 86400;
            if (days > 0) {
                result += `${days}d `;
            }
        }
        const hours = Math.floor(totalSeconds / 3600);
        totalSeconds -= hours * 3600;
        if (hours > 0) {
            result += `${hours}h `;
        }
        const minutes = Math.floor(totalSeconds / 60);
        totalSeconds -= minutes * 60;
        result += `${minutes}m `;
        if (includeSeconds) {
            result += `${totalSeconds}s`;
        }
        return result.trim();
    }

    static jumpToField(e) {
        e.preventDefault();
        const propertyName = $(e.sender.element).attr("data-propertySelector");
        const div = $(`div[data-propertyname='${propertyName}'`);
        if (div.length === 1) {
            const entityBox = div.closest(".EntityBox")[0].id;
            eval(`${entityBox}entityBox`)/* eslint-disable-line no-eval */.jumpToField(propertyName);
        } else {
            CommonFunctions.showError(TextResources.Views_Fehler, TextResources.Error_Generic);
        }
    }

    static getDefaultLanguage(): string {
        return TextResources.Config_DefaultLanguageCode || 'ch';
    }
}
